import { useHistory } from 'react-router-dom';
import ProfileModal from 'components/ProfileModal';
import useUrlSearchParams from 'utils/useUrlSearchParams';
import useRequestSource from 'utils/useRequestSource';

const GlobalProfileModal = () => {
  const search = useUrlSearchParams();
  const uuid = search.get('profile_uuid');

  useRequestSource('GlobalProfileModal', !!uuid);

  const history = useHistory();

  return (
    <ProfileModal
      uuid={uuid}
      onClose={() => history.push(history.location.pathname)}
    />
  );
};

export default GlobalProfileModal;
